export const repair_detail = {
  /** Browser tab title (set by the Async component via useAsyncPageDocumentTitle). */
  documentTitle: "Repair",
  page_title: "Repair",
  back_aria: "Back to repairs",
  status_updates_heading: "Status updates",
} as const;
